//// Activities Isotope ////
// init Isotope
if( document.querySelector('.isotope-container--activities') ){
    var iso = new Isotope('.m-specialisedActivities__container', {
        itemSelector: '.m-specialisedActivity',
        layoutMode: 'fitRows'
    });

    // bind filter button click
    var filters = document.querySelector('.m-specialisedActivities__filters');
    filters.addEventListener('click', function(event) {
        // only work with buttons
        if (!matchesSelector(event.target, 'button')) {
            return;
        }
        var filterValue = event.target.getAttribute('data-filter');

        iso.arrange({
            filter: filterValue
        });

        filters.querySelector('.utl-is-active').classList.remove('utl-is-active');
        event.target.classList.add('utl-is-active');
    });
}
